export enum TemplateKind {
  Sample = 'sample',
  Survey = 'survey'
}
